const Footer = () => {
  const brands = [
    { name: "rising", href: "#" },
    { name: "goget", href: "#" },
    { name: "the jobs 🖨️", href: "#" },
    { name: "the news ☕️", href: "#" },
    { name: "the bizness 🦄", href: "#" },
    { name: "the stories", href: "#" },
    { name: "the champs", href: "#" },
    { name: "health times", href: "#" }
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=League+Spartan:wght@100..900&display=swap');

        .league-spartan {
          font-family: 'League Spartan', sans-serif;
        }
      `}</style>

      <footer className="border-t bg-white dark:bg-gray-900 league-spartan dark:border-gray-700">
        <div className="container mx-auto px-4 py-8">
          <div className="space-y-8">
           {/* Logo and Subscribe Section */}
           <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="text-2xl font-bold text-[#FF3366] flex items-center">
                 <img src="https://app.thenewscc.com.br/logo_waffle.png" alt="Logo" className="w-20 rounded-lg" />
                </div>
                <p className="text-gray-600 dark:text-gray-400">
                  do not follow,<br />
                  consume it.
                </p>
              </div>
            </div>

            {/* Brands Section */}
            <div className="space-y-6">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">nossas marcas</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {brands.map((brand) => (
                  <a
                    key={brand.name}
                    href={brand.href}
                    className="text-gray-600 dark:text-gray-400 hover:text-[#FF3366] dark:hover:text-[#FF3366] transition-colors duration-200"
                  >
                    {brand.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Copyright */}
            <div className="pt-6 border-t border-gray-200 dark:border-gray-700">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                © {new Date().getFullYear()} Grupo waffle de Comunicação. Todos os direitos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export { Footer };